import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { SETTINGS_TOOLTIP_CLASS, StatusTag } from '@/modules/settings';
import type { RuleStatus } from '@/types/rules.types';
import { RULE_STATUS_META } from '../lib/labels';

/** Live / Watching / Draft / Paused, with what it means on hover or focus. */
export function RuleStatusPill({ status }: { status: RuleStatus }) {
	const meta = RULE_STATUS_META[status];
	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<span tabIndex={0} className='rounded-full outline-none focus-visible:ring-2 focus-visible:ring-ring/40'>
					<StatusTag tone={meta.tone}>{meta.label}</StatusTag>
				</span>
			</TooltipTrigger>
			<TooltipContent variant='dark' className={SETTINGS_TOOLTIP_CLASS}>
				{meta.help}
			</TooltipContent>
		</Tooltip>
	);
}
